import { createContext } from "react";

/**
 * Map of normalized `{{token}}` → human label, provided by VariableTextInput so
 * each VarChip NodeView can show a label without prop-drilling through
 * ProseMirror (mirrors the prompt editor's resolution context). A token absent
 * from the map is "unknown" — the chip degrades to its bare name but is never
 * dropped, so the underlying value round-trips unchanged.
 */
export const VarLabelContext = createContext<Map<string, string>>(new Map());
